
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/wymiana-karty/esim/potwierdz-dane",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/wymiana-karty/esim/potwierdz-dane.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/wymiana-karty/esim/potwierdz-dane"])
      });
    }
  